export default {
    SET_INPUT_VALUES: (state, values) =>{
        state.customFields.map((workspaceCustomFields) => {
            if (workspaceCustomFields.workspaceIds.includes(values.workspaceId))
                workspaceCustomFields.info[values.name] = values.value  
        });
        // console.log("state: ", state)
    },
    RESET_INPUT_VALUES: (state, values) =>{
        state.customFields.map((workspaceCustomFields) => {
            if (workspaceCustomFields.workspaceId == values.workspaceId) workspaceCustomFields.inputValues = {}
        });
    }
}
